import axios from "axios";

export default {
  namespaced: true,
  state: () => {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getAllPartner({ commit }, context) {
      const cloneContext = context != null ? context : {};

      commit("setIsLoading", cloneContext.isLoading == false ? false : true, {
        root: true,
      });
      try {
        const request = await axios.post(
          `/api/query?page=${cloneContext.currentPage}`,
          {
            entity: "partners",
            select: ["*"],
            where: [],
            orderBy: { "column": "", "sort": "" },
            aggregate: { "method": "", "column": "" },
            pagination: {
              isPaginate: (context.perPage != null) ? true : false,
              quantity: cloneContext.perPage != null ? cloneContext.perPage : 0,
            },
          }
        );

        let response = null;
        if (request.data.data == null) {
          response = request.data;
        } else {
          response = request.data.data;
        }

        let returnBody = [];

        for (let x of response) {
          returnBody.push({
            id: x.id,
            logo: {
              raw: x.logo,
              html: `<img src="${this._vm.$globalUrl}/storage/images/${x.logo}" />`
            },
            // category: x.category,
          });
        }

        commit("setIsLoading", false, { root: true });
        return {
          head: ["Logo"],
          body: returnBody,
          pagination: {
            per_page: request.data.per_page,
            current_page: request.data.current_page,
            total_pages: request.data.last_page,
          },
        };
      } catch (error) {
        commit("setIsLoading", false, { root: true });
        throw error;
      }
    },
    async getPartner({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.post(
          `/api/query`,
          {
            entity: "partners",
            select: ["*"],
            where: [["id", content.id]],
            orderBy: { "column": "", "sort": "" },
            aggregate: { "method": "", "column": "" },
            pagination: {
              isPaginate: false,
              quantity: 0,
            },
          }
        );

        commit("setIsLoading", false, { root: true });
        return request.data;
      } catch (error) {
        commit("setIsLoading", false, { root: true });
        throw error;
      }
    },
    async createPartner({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.post(`/api/partner`, content);

        commit("setIsLoading", false, { root: true, });
        return request.data;
      } catch (error) {
        commit("setIsLoading", false, { root: true, });
        throw error;
      }
    },
    async updatePartner({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.put(`/api/partner/${content.id}`, content.data);

        commit("setIsLoading", false, { root: true, });
        return request.data;
      } catch (error) {
        commit("setIsLoading", false, { root: true, });
        throw error;
      }
    },
    async deletePartner({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.delete(`/api/partner/${content}`);

        commit("setIsLoading", false, { root: true, });
        return true;
      } catch (error) {
        commit("setIsLoading", false, { root: true, });
        return false;
      }
    },
  },
};
